import { render } from "./inventoryheadertab.vue?vue&type=template&id=89ee4e04"
import script from "./inventoryheadertab.vue?vue&type=script&lang=js"
export * from "./inventoryheadertab.vue?vue&type=script&lang=js"

import "./inventoryheadertab.vue?vue&type=style&index=0&id=89ee4e04&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__